<template>
  <router-view />
</template>

<script>
import { useHead } from '@vueuse/head';

const meta = {
  title:
    'HelixPay Philippines | Ecommerce Technology for Creators & Communities',
  description:
    'Select option that is the best fit for your business needs. HelixPay Checkout is custom built for subscriptions and recurring payments.',
};

export default {
  setup() {
    useHead({
      title: meta.title,
      meta: [
        {
          name: 'title',
          content: meta.title,
        },
        {
          name: 'description',
          content: meta.description,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:title',
          content: meta.title,
        },
        {
          property: 'og:description',
          content: meta.description,
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          property: 'twitter:title',
          content: meta.title,
        },
        {
          property: 'twitter:description',
          content: meta.description,
        },
      ],
    });
  },
};
</script>
